import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../data/services";

export default function Services() {
  return (
    <section id="leistungen" data-testid="services-section" className="hh-section bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="hh-eyebrow mb-5" data-testid="services-eyebrow">Leistungen</div>
            <h2 className="hh-headline text-[2.3rem] sm:text-[3rem] lg:text-[3.6rem] text-[#2E2E2E]">
              Vier Routen.<br />
              <span className="hh-highlight">Ein Hafen.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-body text-[#2E2E2E]/70 text-base sm:text-lg leading-relaxed">
              Wir setzen auf organisches Wachstum durch Strategie, Content und konsistente
              Social-Media-Präsenz. Alles aus einer Hand – ohne Reibungsverlust zwischen
              Beratung, Kreation und Umsetzung.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={s.title} data-testid={`service-card-${i}`} className="hh-card group flex flex-col">
                <div className="w-14 h-14 rounded-2xl bg-[#FFF44F] flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-[#2E2E2E]" strokeWidth={2.2} />
                </div>
                <h3 className="font-display text-[#2E2E2E] text-xl mb-3 leading-tight">{s.title}</h3>
                <p className="font-body text-[#2E2E2E]/70 text-sm leading-relaxed flex-1">{s.desc}</p>
                <ul className="mt-5 space-y-1.5">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 font-body text-[0.83rem] text-[#2E2E2E]/85">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#2185D0]" />
                      {p}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/leistungen/${s.slug}`}
                  data-testid={`service-card-more-${i}`}
                  className="mt-6 inline-flex items-center justify-center gap-1.5 w-full px-4 py-2.5 rounded-full border border-[#2E2E2E]/15 font-display text-[0.85rem] text-[#2E2E2E] hover:bg-[#2E2E2E] hover:text-white hover:border-[#2E2E2E] transition-colors"
                >
                  Nähere Infos <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            );
          })}
        </div>

        {/* "Alles aus einer Hand" highlight banner */}
        <div
          data-testid="all-in-one-banner"
          className="mt-12 rounded-[28px] bg-[#2E2E2E] text-white px-7 py-8 lg:px-12 lg:py-10 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10 relative overflow-hidden"
        >
          <div className="absolute -right-16 -bottom-16 w-56 h-56 rounded-full bg-[#2185D0] opacity-20" aria-hidden />
          <div className="absolute -left-10 -top-10 w-32 h-32 rounded-full border-2 border-[#FFF44F]/25" aria-hidden />

          <div className="relative lg:max-w-md">
            <div className="font-display text-[0.72rem] tracking-[0.22em] uppercase text-[#FFF44F] mb-3">Full-Service</div>
            <h3 className="font-display text-2xl sm:text-3xl leading-tight">
              Alles aus <span className="hh-highlight-strong">einer Hand.</span>
            </h3>
            <p className="font-body text-white/70 text-sm mt-3 leading-relaxed">
              Vom ersten Konzept bis zum Klick auf „Posten" – wir übernehmen den kompletten Prozess.
              Du sparst Abstimmungs-Schleifen, wir liefern konsistenten Content.
            </p>
          </div>

          <div className="relative flex flex-wrap gap-2 lg:gap-3 lg:ml-auto">
            {["Planen", "Drehen", "Bearbeiten", "Posten"].map((step, i) => (
              <div
                key={step}
                data-testid={`workflow-step-${i}`}
                className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-white/5 border border-white/10"
              >
                <span className="font-display text-[0.7rem] text-[#FFF44F] tracking-[0.15em]">0{i + 1}</span>
                <span className="font-display text-white text-sm">{step}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex items-center gap-3 font-body text-sm text-[#2E2E2E]/60" data-testid="services-note">
          <span className="w-8 h-[2px] bg-[#FFF44F]" />
          Andere oder spezifische Leistungen? Sprich uns an – wir bauen passgenau.
        </div>
      </div>
    </section>
  );
}
